var _defs, _use, _use2, _use3, _use4, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "164.73 223.377 18.304 19.816",
    width: 15,
    height: 17
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M172.97 224.43c-1.37-.07-2.75-.07-4.12 0-1.77.2-3.11 1.7-3.1 3.48-.01 3.39-.04 5.62 0 8.96a3.086 3.086 0 002.88 3.3c.06 0 .12.01.18.01 2.57 0 3.99-.02 6.62 0 1.71.13 3.21-1.14 3.35-2.84.01-1.9 0-4.41 0-4.41",
    id: "kpmg-edit_svg__a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.97 224.43c-1.37-.07-2.75-.07-4.12 0-1.77.2-3.11 1.7-3.1 3.48-.01 3.39-.04 5.62 0 8.96a3.086 3.086 0 002.88 3.3c.06 0 .12.01.18.01 2.57 0 3.99-.02 6.62 0 1.71.13 3.21-1.14 3.35-2.84.01-1.9 0-4.41 0-4.41",
    id: "kpmg-edit_svg__b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.36 226a.403.403 0 00-.55.05c-.53.64-4.83 5.76-5.37 6.4-.07.25-.16.54-.25.83.34-.15.66-.29.88-.38.53-.64 4.8-5.72 5.33-6.35.14-.17.12-.41-.04-.55m-4.34 8.17s-1.82.78-2.81 1.21c-.36.15-.63.11-.79-.03-.21-.18-.26-.53-.14-.83.14-.81.79-2.83.79-2.83.56-.66 5.01-5.96 5.57-6.63a1.924 1.924 0 112.94 2.48c-.55.66-5.01 5.96-5.56 6.63z",
    id: "kpmg-edit_svg__c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.36 226a.403.403 0 00-.55.05c-.53.64-4.83 5.76-5.37 6.4-.07.25-.16.54-.25.83.34-.15.66-.29.88-.38.53-.64 4.8-5.72 5.33-6.35.14-.17.12-.41-.04-.55m-4.34 8.17s-1.82.78-2.81 1.21c-.36.15-.63.11-.79-.03-.21-.18-.26-.53-.14-.83.14-.81.79-2.83.79-2.83.56-.66 5.01-5.96 5.57-6.63a1.924 1.924 0 112.94 2.48c-.55.66-5.01 5.96-5.56 6.63z",
    id: "kpmg-edit_svg__d"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kpmg-edit_svg__a",
    fillOpacity: 0
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kpmg-edit_svg__a",
    fillOpacity: 0,
    stroke: "#000",
    strokeOpacity: 0
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kpmg-edit_svg__b",
    fillOpacity: 0
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kpmg-edit_svg__b",
    fillOpacity: 0,
    stroke: "#aa32ba",
    strokeWidth: 1.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kpmg-edit_svg__c",
    fill: "#aa32ba"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kpmg-edit_svg__c",
    fillOpacity: 0,
    stroke: "#000",
    strokeOpacity: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kpmg-edit_svg__d",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kpmg-edit_svg__d",
    fillOpacity: 0,
    stroke: "#000",
    strokeOpacity: 0
  }))));
}

export default SvgKpmgEdit;